import { render, staticRenderFns } from "./Modelos.vue?vue&type=template&id=22ca2fd1&scoped=true"
import script from "./Modelos.vue?vue&type=script&lang=js"
export * from "./Modelos.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=22ca2fd1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ca2fd1",
  null
  
)

export default component.exports